<template>
  <div class="home">
    <navbar v-model="sidebar"></navbar>
    <sidebar v-model="sidebar"></sidebar>
    <div id='map' style="height: calc(100vh - 56px)"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import sidebar from '@/components/sidebar.vue'
import mapboxgl from 'mapbox-gl'
import * as turf from '@turf/turf'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import {ricavi as ricaviG} from '../config.global'

var map
var popup = null

export default {
  name: 'home',
  components: {
    sidebar,
    navbar
  },
  data() {
    return {
      accessToken: "pk.eyJ1IjoidGhlZmxhc2htb2I5NyIsImEiOiJjamxmYWFvdTcwc2FlM3Byb2JrbDdteDdqIn0.hCieGkbt2_aHZATJCECZ2w", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/theflashmob97/cjlf9q2uh044y2spiirdmu5jg",// your map style
      sidebar: this.$sidebar,
      sidebar_old_state: false,
      azienda_pos: 0,
      popup: null
    }
  },
  watch: {
    'sidebar.cerca': function (newQuestion, oldQuestion) {
      this.filtra()
    },
    'sidebar.cercaAziende': function (newQuestion, oldQuestion) {
      this.filtraAziende()
    }
  },
  beforeMount: function () {
    this.sidebar_old_state = this.$sidebar.stato
    this.sidebar.stato = false
  },
  mounted: function () {
    this.loadMap()
  },
  methods: {
    filtra(){
      var data = {
        zona: this.$sidebarValue.zona,
        anno1: this.$sidebarValue.anno1,
        anno2: this.$sidebarValue.anno2,
        trimestre1: this.$sidebarValue.trimestre1,
        trimestre2: this.$sidebarValue.trimestre2,
        categoria: this.$sidebarValue.categoria,
        sottocategoria: this.$sidebarValue.sottocategoria,
        ricavi: this.$sidebarValue.ricavi,
        criterio: this.$sidebarValue.criterio
      }

      Vue.http.post(this.$hostlink+'map/filtro', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.info = response.body.info
        this.setPoint(response.body.data)
        this.setZona(data.zona)

        if(this.$sidebarValue.azienda.id){
          if(this.azienda_pos != this.$sidebarValue.azienda.id){
            this.azienda_pos = this.$sidebarValue.azienda.id
            for(var i=0; i<response.body.data.features.length; i++){
              if(this.$sidebarValue.azienda.id == response.body.data.features[i].properties.id)
                this.infoPoint(response.body.data.features[i])
            }
          }
        }else{
          this.azienda_pos = 0
        }
      })
    },
    filtraAziende(){
      var data = {
        zona: this.$sidebarValue.zona,
        anno1: this.$sidebarValue.anno1,
        anno2: this.$sidebarValue.anno2,
        trimestre1: this.$sidebarValue.trimestre1,
        trimestre2: this.$sidebarValue.trimestre2,
        categoria: this.$sidebarValue.categoria,
        sottocategoria: this.$sidebarValue.sottocategoria,
        ricavi: this.$sidebarValue.ricavi,
        criterio: this.$sidebarValue.criterio
      }

      Vue.http.post(this.$hostlink+'map/filtro/aziende', data, {credentials : true}).then(response => {
        Vue.prototype.$sidebarValue.listaAziende = response.body
        
        Vue.prototype.$sidebar.trovatoAziende = !this.$sidebar.trovatoAziende
        this.$emit('input', this.$sidebar)
      })
    },
    loadMap(){
      var localthis = this
      if(Vue.prototype.$sidebarData.zona.data.length < 2){
        this.sidebar.stato = true
        this.sidebar.stato = false
        setTimeout(this.loadMap, 500);
      }else{
        //centra visuale
        var coordinate = []
        var point = []
        var zona = Vue.prototype.$sidebarValue.zona
        for(var i=0; i<Vue.prototype.$sidebarData.zona.data.length; i++){
          if((zona == 0 || zona == Vue.prototype.$sidebarData.zona.data[i].id) && Vue.prototype.$sidebarData.zona.data[i].coordinate)
            coordinate = coordinate.concat(JSON.parse(Vue.prototype.$sidebarData.zona.data[i].coordinate))
        }
        for(var i=0; i<coordinate.length; i++){
          try{
            point.push(turf.point(coordinate[i]))
          }catch(e){
            //console.log("Multipoligono: "+e)
            for(var j=0; j<coordinate[i].length; j++){
              try{
                point.push(turf.point(coordinate[i][j]))
              }catch(e){
                //console.log("MultiMultipoligono: "+e)
                for(var k=0; k<coordinate[i][j].length; k++){
                  point.push(turf.point(coordinate[i][j][k]))
                }
              }
            }
          }
        }
        mapboxgl.accessToken = this.accessToken
        map = new mapboxgl.Map({
            container: 'map',
            style: this.mapStyle,
            center: turf.center(turf.featureCollection(point)).geometry.coordinates,
            zoom: 10
        })

        map.on('load', function () {
          map.addControl(new MapboxGeocoder({
            accessToken: mapboxgl.accessToken
          }))

          map.addControl(new mapboxgl.NavigationControl())

          map.addControl(new mapboxgl.FullscreenControl())

          map.addControl(new mapboxgl.GeolocateControl({
            positionOptions: {
              enableHighAccuracy: true
            },
            trackUserLocation: true
          }))

          //carica zona
          for(var i=0;i<Vue.prototype.$sidebarData.zona.data.length; i++){
            if(Vue.prototype.$sidebarData.zona.data[i].coordinate){
              map.addLayer({
                  'id': 'Z'+i,
                  'type': 'fill',
                  'source': {
                      'type': 'geojson',
                      'data': {
                          'type': 'Feature',
                          'geometry': {
                              'type': 'MultiPolygon',
                              'coordinates': JSON.parse(Vue.prototype.$sidebarData.zona.data[i].coordinate)
                          }
                      }
                  },
                  'layout': {
                    'visibility': 'none'
                  },
                  'paint': {
                      'fill-color': Vue.prototype.$sidebarData.zona.data[i].colore,
                      'fill-opacity': 0.5
                  }
              })
              if(zona == 0 || zona == Vue.prototype.$sidebarData.zona.data[i].id)
                map.setLayoutProperty('Z'+i, 'visibility', 'visible')
            }
          }
          
          //carica punti
          var data = {
            zona: Vue.prototype.$sidebarValue.zona,
            anno1: Vue.prototype.$sidebarValue.anno1,
            anno2: Vue.prototype.$sidebarValue.anno2,
            trimestre1: Vue.prototype.$sidebarValue.trimestre1,
            trimestre2: Vue.prototype.$sidebarValue.trimestre2,
            categoria: Vue.prototype.$sidebarValue.categoria,
            sottocategoria: Vue.prototype.$sidebarValue.sottocategoria,
            ricavi: Vue.prototype.$sidebarValue.ricavi,
            criterio: Vue.prototype.$sidebarValue.criterio,
            azienda: Vue.prototype.$sidebarValue.azienda
          }

          Vue.http.post(Vue.prototype.$hostlink+'map/filtro', data, {credentials : true}).then(response => {
            Vue.prototype.$sidebarValue.info = response.body.info
            // Add a new source from our GeoJSON data and set the
            // 'cluster' option to true. GL-JS will add the point_count property to your source data.
            map.addSource("earthquakes", {
                type: "geojson",
                data: response.body.data,
                cluster: true,
                clusterMaxZoom: 30, // Max zoom to cluster points on
                clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
            })

            map.addLayer({
                id: "clusters",
                type: "circle",
                source: "earthquakes",
                filter: ["has", "point_count"],
                paint: {
                    // Use step expressions (https://www.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                    // with three steps to implement three types of circles:
                    //   * Blue, 20px circles when point count is less than 100
                    //   * Yellow, 30px circles when point count is between 100 and 750
                    //   * Pink, 40px circles when point count is greater than or equal to 750
                    "circle-color": [
                        "step",
                        ["get", "point_count"],
                        "#51bbd6",
                        100,
                        "#f1f075",
                        750,
                        "#f28cb1"
                    ],
                    "circle-radius": [
                        "step",
                        ["get", "point_count"],
                        20,
                        100,
                        30,
                        750,
                        40
                    ]
                }
            })

            map.addLayer({
                id: "cluster-count",
                type: "symbol",
                source: "earthquakes",
                filter: ["has", "point_count"],
                layout: {
                    "text-field": "{point_count_abbreviated}",
                    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                    "text-size": 12
                }
            })

            map.addLayer({
                id: "unclustered-point",
                type: "circle",
                source: "earthquakes",
                filter: ["!", ["has", "point_count"]],
                paint: {
                    "circle-color": "#11b4da",
                    "circle-radius": 6,
                    "circle-stroke-width": 1,
                    "circle-stroke-color": "#fff"
                }
            })

            // inspect a cluster on click
            map.on('click', 'clusters', function (e) {
                var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] })
                var clusterId = features[0].properties.cluster_id
                map.getSource('earthquakes').getClusterExpansionZoom(clusterId, function (err, zoom) {
                    if (err)
                        return

                    map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    })
                })
            })

            map.on('click', 'unclustered-point', function (e) {
              localthis.infoPoint(e.features[0])
            })

            map.on('mouseenter', 'clusters', function () {
                map.getCanvas().style.cursor = 'pointer'
            })
            map.on('mouseleave', 'clusters', function () {
                map.getCanvas().style.cursor = ''
            })
          })
        })

        //sidebar fix
        this.sidebar.stato = this.sidebar_old_state
      }
    },
    setZona(zona){
      var coordinate = []
      var point = []
      for(var i=0; i<Vue.prototype.$sidebarData.zona.data.length; i++){
        if((zona == 0 || zona == Vue.prototype.$sidebarData.zona.data[i].id) && Vue.prototype.$sidebarData.zona.data[i].coordinate)
          coordinate = coordinate.concat(JSON.parse(Vue.prototype.$sidebarData.zona.data[i].coordinate))
      }

      for(var i=0; i<coordinate.length; i++){
        try{
          point.push(turf.point(coordinate[i]))
        }catch(e){
          //console.log("Multipoligono: "+e)
          for(var j=0; j<coordinate[i].length; j++){
            try{
              point.push(turf.point(coordinate[i][j]))
            }catch(e){
              //console.log("MultiMultipoligono: "+e)
              for(var k=0; k<coordinate[i][j].length; k++){
                point.push(turf.point(coordinate[i][j][k]))
              }
            }
          }
        }
      }

      map.flyTo({center: turf.center(turf.featureCollection(point)).geometry.coordinates})

      for(var i=0;i<Vue.prototype.$sidebarData.zona.data.length; i++){
        if(Vue.prototype.$sidebarData.zona.data[i].coordinate){
          if(zona == 0 || zona == Vue.prototype.$sidebarData.zona.data[i].id)
            map.setLayoutProperty('Z'+i, 'visibility', 'visible')
          else
            map.setLayoutProperty('Z'+i, 'visibility', 'none')
        }
      }
    },
    setPoint(punti){
      map.getSource('earthquakes').setData(punti)
    },
    getRicavi(ricavo, trimestre){
      if(trimestre == null)
        trimestre = 1
      
      var ricavi = [this.formatNumber(ricaviG[0][0]*trimestre)+' - '+this.formatNumber(ricaviG[0][1]*trimestre),
        this.formatNumber(ricaviG[1][0]*trimestre)+' - '+this.formatNumber(ricaviG[1][1]*trimestre),
        this.formatNumber(ricaviG[2][0]*trimestre)+' in su']
      
      if(ricavo >= ricaviG[0][0]*trimestre && ricavo < ricaviG[0][1]*trimestre)
        return ricavi[0]
      if(ricavo >= ricaviG[1][0]*trimestre && ricavo < ricaviG[1][1]*trimestre)
        return ricavi[1]
      if(ricavo >= ricaviG[2][0]*trimestre)
        return ricavi[2]
    },
    formatNumber(n){
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n)
    },
    infoPoint(elm){
      if(popup != null)
        popup.remove()

      map.flyTo({center: elm.geometry.coordinates})
              
      var coordinates = elm.geometry.coordinates.slice()  
      var description = "<h6><strong>"+elm.properties.ragione+"</strong> ("+elm.properties.zona+")</h6>"+
        "<div>"+elm.properties.com_ind+", "+elm.properties.comune+"</div>"+
        "<div>"+elm.properties.categoria+"</div>"+
        "<div>"+elm.properties.sottocategoria+"</div>"+
        (elm.properties.ricavi >= ricaviG[0][0] ? "Ricavi: "+this.getRicavi(elm.properties.ricavi, elm.properties.trimestre) : "")

      popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(map)
    }
  }
}
</script>

<style>
@import url('https://api.tiles.mapbox.com/mapbox-gl-js/v0.50.0/mapbox-gl.css');
</style>
